import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import HomeShop from "../../Home/HomeShop";
import AboutUsShop from "../../AboutUs/AboutUsShop";

export default function ShopRoutes() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={HomeShop} />
                <Route exact path="/aboutus" component={AboutUsShop} />
                <Redirect to="/" />
            </Switch>
        </Router>
    );
}

